import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, } from 'reactstrap';
import { isEmpty, } from 'lodash';
import { useAsync, } from 'react-use';
import numeral from 'numeral';

import { getCollectionData, } from '../../shared/firebase';
import { computeSimilarUsers, normalizePostalCode, } from '../../shared/models/userSimilarity';
import { postalCodeWithHyphen, } from '../../shared/util';
import { allPrefectures, } from '../../shared/config';
import TenantLink from '../TenantLink';

export default function SimilarUsersModal (props) {
  const { isOpen, onClickClose, tenant, user, } = props;
  const country = tenant.salesCountry || 'jp';
  const prefecturesOfCountry = allPrefectures[country] || {};
  const postalCode = normalizePostalCode(user.postalCode);

  const { value: similarUsers, loading, error, } = useAsync(async () => {
    if(isEmpty(postalCode)) return [];

    const candidates = await getCollectionData(
      tenant.ref.collection('tenantUsers').where('postalCode', '==', user.postalCode)
    );
    return computeSimilarUsers(user, candidates);
  }, [tenant.id, user.id, user.postalCode]);

  return (
    <Modal isOpen={isOpen} style={{ minWidth: '80vw', }}>
      <div className="modal-header">
        <h5 className="modal-title">
          類似アカウント検索
        </h5>
      </div>
      <ModalBody>
        <div className="mb-3 text-muted small">
          郵便番号「{postalCodeWithHyphen(country, user.postalCode) || '未登録'}」が一致するアカウントの中から、氏名・住所が類似するものを表示しています。
        </div>
        {
          isEmpty(postalCode) ? (
            <div className="alert alert-warning mb-0">
              このアカウントには郵便番号が登録されていないため検索できません。
            </div>
          ) : loading ? (
            <div className="d-flex justify-content-center py-4">
              <span className="fas fa-spin fa-spinner fa-2x" />
            </div>
          ) : error != null ? (
            <div className="alert alert-danger mb-0">
              検索に失敗しました。
            </div>
          ) : isEmpty(similarUsers) ? (
            <div className="alert alert-info mb-0">
              類似するアカウントは見つかりませんでした。
            </div>
          ) : (
            <table className="table table-bordered table-sm">
              <thead className="thead-light">
                <tr>
                  <th style={{ width: 100 }}>類似度</th>
                  <th>お名前</th>
                  <th>ふりがな</th>
                  <th>電話番号</th>
                  <th>住所</th>
                  <th style={{ width: 100 }}></th>
                </tr>
              </thead>
              <tbody>
                {
                  similarUsers.map(({ score, user: similarUser, }) => {
                    const { id, displayName, nameKana, phone, prefecture, city, address, } = similarUser;
                    return (
                      <tr key={id}>
                        <td>
                          <span className={`badge badge-${score >= 0.8 ? 'danger' : score >= 0.6 ? 'warning' : 'secondary'}`}>
                            {numeral(score).format('0%')}
                          </span>
                        </td>
                        <td>{displayName}</td>
                        <td>{nameKana}</td>
                        <td>{phone}</td>
                        <td>{[prefecturesOfCountry[prefecture], city, address].filter(_ => !isEmpty(_)).join(' ')}</td>
                        <td>
                          <Button size="sm" tag={TenantLink} to={`/admin/users/${id}`} target="_blank">
                            詳細
                            <span className="fas fa-external-link-alt ml-1" />
                          </Button>
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          )
        }
      </ModalBody>
      <ModalFooter>
        <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
      </ModalFooter>
    </Modal>
  );
};
